import { BaseError } from '@dynamic-labs-sdk/client';

type FeeRecommendationsFetchErrorParams = {
  response: Response;
};

export class FeeRecommendationsFetchError extends BaseError {
  public readonly response: Response;

  constructor({ response }: FeeRecommendationsFetchErrorParams) {
    super({
      cause: null,
      code: 'fee_recommendations_fetch_error',
      details: `Status: ${response.status} ${response.statusText}`,
      docsUrl: null,
      name: 'FeeRecommendationsFetchError',
      shortMessage: 'Failed to fetch fee recommendations from mempool',
    });

    this.response = response;
  }
}
